import React from 'react';
import RelatedArticles from '../related-articles/RelatedArticles';
import { New } from '../../../domain/graphcms';
import { buildArticleURLObject, slugIt } from '../../utils/links';
import { ArticleType } from '../../../domain/articleType';

export interface FeaturesNewsWidgetProps {
  title: string,
  news: New[],
}

export const FeaturesNewsWidget: React.FC<FeaturesNewsWidgetProps> = ({
  title,
  news,
}) => {
  const newsArticle = React.useMemo(() => news.map((newItem) => ({
    id: newItem.id,
    title: newItem.title,
    thumbnail: {
      alt: newItem.imageBlock.imageAlt,
      url: newItem.imageBlock.image.url,
    },
    urlObject: buildArticleURLObject({
      id: newItem.id,
      slug: slugIt(newItem.alternateTitle || newItem.title),
    }, ArticleType.NEWS),
  })), [news]);

  return (
    <RelatedArticles
      title={title}
      items={newsArticle}
    />
  );
};

export default FeaturesNewsWidget;
